import { createContext, useContext, useCallback, useEffect, useState } from "react";
import api from "@/lib/api";

const NotificationsContext = createContext(null);

export function NotificationsProvider({ children }) {
  const [items, setItems] = useState([]);
  const unread = items.filter((n) => !n.read).length;

  const refresh = useCallback(async () => {
    if (!localStorage.getItem("mpf_token")) return;
    try {
      const { data } = await api.get("/notifications");
      setItems(data);
    } catch {
      /* ignore */
    }
  }, []);

  const markRead = useCallback(async (id) => {
    await api.put(`/notifications/${id}/read`);
    await refresh();
  }, [refresh]);

  const markAllRead = useCallback(async () => {
    await api.put("/notifications/read-all");
    await refresh();
  }, [refresh]);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <NotificationsContext.Provider value={{ items, unread, refresh, markRead, markAllRead }}>
      {children}
    </NotificationsContext.Provider>
  );
}

export const useNotifications = () => useContext(NotificationsContext);
